import { createFeature, createReducer, on } from '@ngrx/store';
import { produce } from 'immer';
import { ArbeitszeitkontoInvalidation } from '../../server-side-events/arbeitszeitkonto-invalidation';
import { PausenUeberpruefung } from '../../server-side-events/pausenueberpruefung';
import { InvalidationsActions } from './invalidations.actions';

export const invalidationsFeatureKey = 'invalidations';

export interface State {
  arbeitszeitkontoInvalidations: { [mitarbeiterId: string]: ArbeitszeitkontoInvalidation[] | undefined };
  pausenUeberpruefungen: { [mitarbeiterId: string]: PausenUeberpruefung[] | undefined };
}

export const initialState: State = {
  arbeitszeitkontoInvalidations: {},
  pausenUeberpruefungen: {},
};

export const reducer = createReducer(
  initialState,
  on(
    InvalidationsActions.fillArbeitszeitKontoInvalidations,
    (state, { azkInvalidations }): State =>
      produce(state, (draft) => {
        draft.arbeitszeitkontoInvalidations = {};
        if (azkInvalidations === undefined || azkInvalidations.length === 0) {
          return;
        }
        const groupedInvalidations = azkInvalidations.reduce((acc, invalidation) => {
          const mitarbeiterId = invalidation.MitarbeiterId;
          if (!acc[mitarbeiterId]) {
            acc[mitarbeiterId] = [];
          }

          acc[mitarbeiterId].push(invalidation);
          return acc;
        }, {} as { [mitarbeiterId: string]: ArbeitszeitkontoInvalidation[] });

        Object.keys(groupedInvalidations).forEach(mitarbeiterId => {
          draft.arbeitszeitkontoInvalidations[mitarbeiterId] = groupedInvalidations[mitarbeiterId];
        });
      })
  ),
  on(
    InvalidationsActions.fillPausenueberpruefungen,
    (state, { pausenUeberpruefungen }): State =>
      produce(state, (draft) => {
        draft.pausenUeberpruefungen = {};
        if (pausenUeberpruefungen === undefined || pausenUeberpruefungen.length === 0) {
          return;
        }
        const groupedPausenUeberpruefungen = pausenUeberpruefungen.reduce((acc, pausenUeberpruefung) => {
          const mitarbeiterId = pausenUeberpruefung.MitarbeiterID;
          if (!acc[mitarbeiterId]) {
            acc[mitarbeiterId] = [];
          }

          acc[mitarbeiterId].push(pausenUeberpruefung);
          return acc;
        }, {} as { [mitarbeiterId: string]: PausenUeberpruefung[] });

        Object.keys(groupedPausenUeberpruefungen).forEach(mitarbeiterId => {
          draft.pausenUeberpruefungen[mitarbeiterId] = groupedPausenUeberpruefungen[mitarbeiterId];
        });
      })
  )
);


export const invalidationsFeature = createFeature({
  name: invalidationsFeatureKey,
  reducer: reducer,
});
